import { render } from "./PerformancesList.vue?vue&type=template&id=34934a38&ts=true"
import script from "./PerformancesList.vue?vue&type=script&lang=ts"
export * from "./PerformancesList.vue?vue&type=script&lang=ts"

import "./PerformancesList.vue?vue&type=style&index=0&id=34934a38&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__